import { usePortal } from "../../Providers/PortalProvider";
import { PRODUCT_DIGITAL_FILE_UUID, PRODUCT_DIGITAL_GROUP_FILE_UUID, PRODUCT_DIGITAL_GROUP_SET_UUID, PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID, PRODUCT_DIGITAL_MINI_GROUP_SET_UUID, PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_FILE_UUID, PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_SET_UUID, PRODUCT_DIGITAL_SET_UUID, usePriceList, } from "../providers/PriceListProvider";
const useDigitalRebate = () => {
    const portal = usePortal();
    const priceList = usePriceList();
    const { digitalRebate } = portal.webshop;
    const fileProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_FILE_UUID);
    let digitalFileRebatedPrice = digitalRebate.portraitFilePrice;
    if (!fileProduct ||
        digitalFileRebatedPrice > fileProduct.productprices[0].price) {
        digitalFileRebatedPrice = null;
    }
    const digitalSetProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_SET_UUID);
    let digitalSetRebatedPrice = digitalRebate.portraitSetPrice;
    if (!digitalSetProduct ||
        digitalSetRebatedPrice > digitalSetProduct.productprices[0].price) {
        digitalSetRebatedPrice = null;
    }
    const getRebatedSetPriceByType = (type) => {
        let setProduct = null;
        let rebatedPrice = null;
        if (type === "IP") {
            setProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_SET_UUID);
            if (!setProduct) {
                setProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_SET_UUID);
            }
            rebatedPrice = digitalRebate.portraitSetPrice;
        }
        else if (type === "SFP") {
            setProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_MINI_GROUP_SET_UUID);
            rebatedPrice = digitalRebate.siblingAndFriendsSetPrice;
        }
        else if (type === "GP") {
            setProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_GROUP_SET_UUID);
            rebatedPrice = digitalRebate.groupSetPrice;
        }
        if (!setProduct ||
            rebatedPrice === null ||
            rebatedPrice > setProduct.productprices[0].price) {
            return null;
        }
        return rebatedPrice;
    };
    const getRebatedFilePriceByType = (type) => {
        let fileProduct = null;
        let rebatedPrice = null;
        if (type === "IP") {
            fileProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_FILE_UUID);
            if (!fileProduct) {
                fileProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_FILE_UUID);
            }
            rebatedPrice = digitalRebate.portraitFilePrice;
        }
        else if (type === "SFP") {
            fileProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID);
            rebatedPrice = digitalRebate.siblingAndFriendsFilePrice;
        }
        else if (type === "GP") {
            fileProduct = priceList === null || priceList === void 0 ? void 0 : priceList.getProductByUuid(PRODUCT_DIGITAL_GROUP_FILE_UUID);
            rebatedPrice = digitalRebate.groupFilePrice;
        }
        if (!fileProduct ||
            rebatedPrice === null ||
            rebatedPrice > fileProduct.productprices[0].price) {
            return null;
        }
        return rebatedPrice;
    };
    return {
        digitalFileRebatedPrice,
        digitalSetRebatedPrice,
        getRebatedSetPriceByType,
        getRebatedFilePriceByType,
    };
};
export default useDigitalRebate;
